import { ACCORDIAN, getPaymentMethodPriority } from "constants/index";
import { PAYMENT_MODES } from "constants/paymentModes";
import { checkIfLastPaymentInfoVisible, getSavedAvailableMethods } from "../../../../../logics/src/helper";
import { toLowerCase } from "../../../../../logics/src/utils/toLowerCase";
import { isOnlyUpiIntentAvailable } from "helpers/utils";


export const getValidSavedMethod = ({
  paymentContext,
  isGPayIntentAvailable,
  isApp
}: any) => {
  const savedMethods = ["upi_intent", "cc", "nb", "upi", "paytm", "simpl"];
  const remoteMethods = ["last", "upi_intent", "cc", "upi", "paytm", "simpl"];
  const paymentInfo = paymentContext?.paymentInfo;
  const cartInfo = paymentContext?.cartInfo;
  const availableMethods = cartInfo?.availablePaymentMethods;
  const pciEnabled = paymentContext?.pciEnabled;
  const customerVpaList = paymentInfo?.customerVpaList;
  const lastPaymentInfo = paymentInfo?.lastPaymentInfo;

  let methods: any[] = [];

  let savedAvailableMethods = getSavedAvailableMethods({
    savedMethods,
    paymentInfo,
    availableMethods,
    pciEnabled,
  });
  savedAvailableMethods = savedAvailableMethods.filter(method => {
    return method !== PAYMENT_MODES.INTENT;
  });

  // upi intent in last payment info
  if (
    (isApp && Array.isArray(customerVpaList) && toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode) === toLowerCase(PAYMENT_MODES.INTENT))  ||
    (isGPayIntentAvailable && toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode) === toLowerCase(PAYMENT_MODES.INTENT))
  ) {
    savedAvailableMethods.unshift(PAYMENT_MODES.INTENT);
  }
  // checking whether last payment info is visible
  const isLastPaymentInfoVisible = checkIfLastPaymentInfoVisible(
    paymentInfo,
    availableMethods,
    pciEnabled
  );

  /**
   *  Show last paymentmethod only if
   *  these three paymentMode available
   */
  let isValidLastPaymentMethod = false;
  let lastPaymentMode: string = toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode);

  switch (lastPaymentMode) {
    case ACCORDIAN.NETBANKING:
      isValidLastPaymentMethod = true;
      break;
    case ACCORDIAN.UPI:
      isValidLastPaymentMethod = true;
      break
    case ACCORDIAN.SIMPL:
      isValidLastPaymentMethod = true && Object.keys(paymentInfo?.simplDTO || {}).length !== 0;
      break
  }

  // adding last payment info to the start of the array if available
  if (isLastPaymentInfoVisible && isValidLastPaymentMethod) {
    savedAvailableMethods.unshift(ACCORDIAN.LAST_METHOD);
  }

  // if remotePaymentMethods exists and then set methods that are in savedAvailableMethods
  // in order of remotePaymentMethods
  if (
    Array.isArray(savedAvailableMethods) &&
    savedAvailableMethods.length > 0 &&
    Array.isArray(remoteMethods) &&
    remoteMethods.length > 0
  ) {
    const finalMethods: string[] = [];
    remoteMethods.forEach((method) => {
      if (method && savedAvailableMethods.includes(method)) {
        finalMethods.push(method);
      }
    });

    methods = finalMethods;
  } else if (
    Array.isArray(savedAvailableMethods) &&
    savedAvailableMethods.length > 0
  ) {
    // when remotePaymentMethods does not exists or fetched use savedAvailableMethods
    methods = savedAvailableMethods;
  }

  return methods as [string];


}

export const getValidNewPaymentMethod = (availablePaymentMethods: string[], isGPayIntentAvailable:boolean, isGuest:boolean, isDesktop?: boolean) => {
  let newPaymentMethod = ["cc", "upi", "cred", "nb", "simpl", "zest_money", "cod", "paytm", "gift", "wallet", "emi"];
  /**
   * Adding upi_intent method for desktop flow to handle UPI QR Code in case UPI Collect is disabled.
   * or in case only intent is available and collect is disabled.
   */
  if (isOnlyUpiIntentAvailable(availablePaymentMethods) || isDesktop) {
    newPaymentMethod.push("upi_intent");
  }

  /**
   * filter out all new payment method according to methods present in availablePaymentMethods
   */
  newPaymentMethod = newPaymentMethod.filter((method: string) => availablePaymentMethods.includes(method));

  /**
   * snpl method is only available for logged in user
   */
  if (!isGuest && (newPaymentMethod.includes("simpl") || newPaymentMethod.includes("zest_money"))) {
    newPaymentMethod.splice(3, 0, "snpl");
  }
  /**
   * priority for new payment method
   */
  const paymentMethodPriorityConfig = getPaymentMethodPriority();
  let newpaymentMethodWithPriority = newPaymentMethod.map((method)=>{
    return {
      method: method,
      priority: paymentMethodPriorityConfig[method] || 11
    }
  })
  /**
   * sorting payment method based on priority
   */
  newpaymentMethodWithPriority = newpaymentMethodWithPriority.sort((a,b)=>a.priority-b.priority);
  /**
   * converting  back from array of objects to array of strings
   * i.e removing priority.
   */
  newPaymentMethod = newpaymentMethodWithPriority.map((config)=>config.method); 
  return newPaymentMethod
}
